import React, {useEffect, useState} from 'react';
import {useIntl} from "react-intl";
import {Grid, Stack} from "@mui/material";
import FormFieldText from "../../../../components/FormFieldText";
import SearchButton from "../../../../components/buttons/SearchButton";
import {PersonSearchCondition} from "../../../../modules/exos/dto/PersonSearchCondition";

export type SearchConditionProps = {
    searchCondition: PersonSearchCondition;
    onChange: (name: string, value: any) => void;
    onSearch: () => void;
};

const SearchCondition: React.FC<SearchConditionProps> = (props) => {
    const intl = useIntl();

    return (
        <Grid container columnSpacing={2} alignItems="center">
            <Grid item xs={3}>
                <FormFieldText label={intl.formatMessage({id: "EXOS_STAFF_NO"})}
                               value={props.searchCondition.staffNo}
                               onChange={(value) => {
                                   props.onChange("staffNo", value)
                               }}/>
            </Grid>

            <Grid item xs={3}>
                <FormFieldText label={intl.formatMessage({id: "EXOS_STAFF_FULL_NAME"})}
                               value={props.searchCondition.name}
                               onChange={(value) => {
                                   props.onChange("name", value)
                               }}/>
            </Grid>
            <Grid item xs={3}>
                <FormFieldText label={intl.formatMessage({id: "EXOS_STAFF_BADGE_NO"})}
                               value={props.searchCondition.badgeNo}
                               onChange={(value) => {
                                   props.onChange("badgeNo", value)
                               }}/>
            </Grid>

            <Grid item xs={3}>
                <SearchButton onClick={() => props.onSearch()}/>
            </Grid>
        </Grid>
    );
};

export default SearchCondition;
